import { FC, CSSProperties } from 'react';
import {
  Theme,
  Typography,
  TypographyProps,
  makeStyles,
} from '@material-ui/core';
import { WbTooltip, WbTooltipProps } from '../WbTooltip';
import clsx from 'clsx';

export const useTruncatedStyles = makeStyles<
  Theme,
  { maxLines?: number; breakAll?: boolean }
>({
  truncated: ({ maxLines = 2, breakAll = false }) => ({
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': maxLines,
    overflow: 'hidden',
    display: '-webkit-box',
    wordBreak: breakAll ? 'break-all' : 'break-word',
    textOverflow: 'ellipsis',
  }),
});

export const WbTruncatedTypographyWrapper: FC<{
  value: string;
  style?: CSSProperties;
  maxLines?: number;
  breakAll?: boolean;
  enableTooltip?: boolean;
  tooltipProps?: Partial<WbTooltipProps>;
  placement?: string;
  variant?: TypographyProps['variant'];
  customClass?: string;
}> = ({
  value,
  style,
  maxLines = 2,
  breakAll = false,
  enableTooltip = true,
  tooltipProps,
  placement = 'bottom-start' as any,
  variant,
  customClass,
}) => {
  const classes = useTruncatedStyles({ maxLines, breakAll });
  return (
    <WbTooltip
      placement={placement}
      title={enableTooltip ? value : ''}
      {...tooltipProps}
    >
      <Typography
        className={clsx(classes.truncated, customClass)}
        style={style}
        variant={variant}
      >
        {value}
      </Typography>
    </WbTooltip>
  );
};
